import { createFileRoute } from "@tanstack/react-router";
import { TelevisionServicePage } from "./services_.television";

export const Route = createFileRoute("/service_/television-advertising-services")({
  head: () => ({
    meta: [
      {
        title: "Television Advertising Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Television Advertising Services That Maximise Brand Reach & Business Growth.",
      },
    ],
  }),
  component: TelevisionServicePage,
});
